import { ReactPropTypes } from "react";

interface EditorWidgetProps {
  widget: any;
}

const EditorWidget = ({ widget }: EditorWidgetProps) => {
  var html = widget.EditorWidget?.Content?.Html;

  if (html) {
    return <div dangerouslySetInnerHTML={{ __html: html }}></div>;
  }

  return null;
};

export default EditorWidget;
export type { EditorWidgetProps };
